// src/pages/PublicPage.jsx
import React from "react";
import ESGCheckpoint from "../components/splash/esg_Checkpoint";
import UseCase from "../components/splash/useCase";
import { useScrollReveal } from "../hooks/useScrollReveal";

export default function PublicPage() {
  const heroRef = useScrollReveal();
  const esgRef = useScrollReveal();
  const useCaseRef = useScrollReveal(); 

  return (
    <div className="page-main" data-scroll-container>
      <div className="page-main-inner">

        {/* HERO / INTRO */}
        <section
          ref={heroRef}
          className="page-hero reveal-section"
          data-scroll
          data-scroll-speed="0.5"
        >
          <h1 className="page-hero__title">
            sustina – finding opportunities in ESG compliance
          </h1>

          <p className="page-hero__lead">
            Compliance shouldn&apos;t just be a cost of staying in business.
            Done right, ESG exposes hidden efficiencies, opens up new markets,
            and builds trust with the people who matter most.
          </p>
        </section>

        {/* ESG VENN CHECKPOINT */}
        <section
          ref={esgRef}
          className="page-section page-section--esg reveal-section"
          data-scroll
          data-scroll-speed="0.8"
        >
          <div className="esg-background">
            <ESGCheckpoint />
          </div>
          <hr />
        </section>

        {/* ORG USE CASE SLIDER */}
        <section
          ref={useCaseRef}
          className="page-section page-section--usecase reveal-section"
          aria-label="ESG use cases across the organisation"
          data-scroll
          data-scroll-speed="0.8"
        >
          <header className="page-hero">
            <h2 className="page-hero__title">
              Where ESG actually shows up in the org chart
            </h2>

            <p className="page-hero__lead">
              Sustainability compliance is frequently considered an issue for the very large businesses
              – but in reality, ESG touches every part of an organisation. 
              The legislators have, via a back door ensured that all companies will eventually HAVE to take more notice 
              of their Environmental, Social and Governance impacts. <br /> How ?<br /> 
              The big companies WILL seek facts, figures and declarations from you as part of their compliance.<br />
              How you affect their footprint, their compliance will directly affect your ongoing ability to trade with them.
            </p>

            <p className="page-hero__lead">
              Different teams see different parts of the risk. This view pulls
              those exposures together so you can see the whole picture – from
              executive decisions to day-to-day operations.
            </p>
          </header>

          <UseCase />
        </section>

      </div>
    </div>
  );
}